import MarketPersonas from "./marketPersonas";

export default MarketPersonas;
